// The caller's organization role outside a game (the organization pages and the games list render in the PlainLayout,
// without `useGame`): read from `GET /v1/me` memberships; owners and admins manage, members only read.
import type { OrgRole } from '../../api/types';
import { useAuth } from '../../auth/AuthContext';
import { useQuery } from '../../workspace/cache';
import { orgRoleManages } from '../settings/keys';

export interface OrgAccess {
  role: OrgRole | null;
  loading: boolean;
  manages: boolean;
  /** the permission missing for an organization write, or null */
  missing: (permission: string) => string | null;
}

export function useOrgAccess(org: string): OrgAccess {
  const { client } = useAuth();
  const me = useQuery('me', () => client.me());
  const membership = (me.data?.memberships ?? []).find((m) => m.organization.slug === org || m.organization.id === org);
  const role = membership?.role ?? null;
  const manages = orgRoleManages(role);
  return { role, loading: me.loading, manages, missing: (permission) => (manages ? null : permission) };
}
